import { TFunctionType } from 'shared/entities/localization';

import {
  ActualNameCreator,
  createActualBlockName,
  normalizeCommonFields
} from '../../block/common';
import { normalizeGoogleBasicParams } from '../GoogleBasic';

import { ActionSetCellGoogleSheetsParamsServer } from './server';
import {
  ActionSetCellGoogleSheetsNormalizer,
  IActionSetCellGoogleSheetsParams
} from './client';

export const normalizeActionSetCellGoogleSheetsParams = (
  raw: ActionSetCellGoogleSheetsParamsServer
): IActionSetCellGoogleSheetsParams => ({
  value: raw.value || '',
  cellId: raw.cell_id || '',
  ...normalizeGoogleBasicParams(raw)
});

const createActionSetCellGoogleSheetsActualNameBase = (
  tableName: string | null,
  t: TFunctionType
) => {
  return tableName
    ? t('block.ActionSetCellGoogleSheets.actualName', {
        ns: 'entities',
        tableName
      })
    : '';
};

export const createActionSetCellGoogleSheetsActualName: ActualNameCreator<
  IActionSetCellGoogleSheetsParams
> = ({ params, t }) =>
  createActionSetCellGoogleSheetsActualNameBase(params.table?.name || null, t);

export const normalizeActionSetCellGoogleSheets: ActionSetCellGoogleSheetsNormalizer =
  (raw, stores) => {
    return {
      ...normalizeCommonFields(raw, stores),
      actualName: (t) =>
        createActualBlockName({
          paramsName: createActionSetCellGoogleSheetsActualNameBase(
            raw.params.table_name || null,
            t
          ),
          blockKind: raw.kind,
          blockName: raw.name,
          t,
          ...stores
        })
    };
  };
